import React from "react";
import "./Carosel.css";
import Slider from "react-slick";
import { IMAGE_BASE_PATH_DBRADC, IMAGE_BASE_PATH_COMMON } from "../../Config/Config";

const Image_Carosel = (props) => {
  const { image_data, imageStyle } = props;
  const defaultStyles = {
    width: "100%",
    height: "390px",
    objectFit: "cover",
    borderRadius: "8px",
  };

  // Function to get the image URL based on the data structure
  const getImageUrl = (item) => {
    if (typeof item === 'string') {
      // If it's a string, return it directly
      return item;
    } else if (item && typeof item === 'object') {
      // If it's an object, check for image_url
      return item.image_url ? IMAGE_BASE_PATH_DBRADC + item.image_url : IMAGE_BASE_PATH_COMMON + "Placeholders/Placeholder_Image.jpg";
    }
    // Fallback to placeholder if no valid data is found
    return IMAGE_BASE_PATH_COMMON + "Placeholders/Placeholder_Image.jpg";
  };

  return (
    <div className="Image_carosel">
      <Slider ref={(slider) => (slider)} arrows={false} autoplay={true} dots={true}>
        {image_data &&
          image_data.map((item, index) => {
            const imageUrl = getImageUrl(item); // Get the correct image URL

            return (
              <div key={index}>
                <img
                  src={imageUrl}
                  alt="Event"
                  style={imageStyle ? { ...defaultStyles, ...imageStyle } : defaultStyles}
                />
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default Image_Carosel;
